import { LoadBankType } from "./Enums";

export class LoadBank {
    loadBankId: number = 0;
    loadBankType: LoadBankType = LoadBankType.Load;
    loadNumber: string = '';
    description: string = '';
    locCode: string = '';
    contractId: number = 0;
    contractNumber: string = '';
    locationId: number = 0;
    locationName: string = '';
    locationCity: string = '';
    locationState: string = '';
    customerId: number = 0;
    customerName: string = '';
    customerCode: string = '';
    shipFrom: string = '';
    shipTo: string = '';
    commodityCode: string = '';
    username: string = '';
    createdBy: string = '';
    createdDate: string = '';
    isSelected: boolean = false;
}